import "./ProfileCard.css"

import { Card, Tag, Space, Typography, Button, message } from 'antd';
import React, { useState } from 'react';
import { 
  UserOutlined,
  BookOutlined,
  BankOutlined,
  MailOutlined,
  PhoneOutlined,
  WechatOutlined,
  LinkedinOutlined,
  GlobalOutlined,
  EnvironmentOutlined,
  EditOutlined,
  CopyOutlined,
  CalendarOutlined,
  TeamOutlined,
  HomeOutlined
} from "@ant-design/icons";
import { getFieldDisplayName } from "../../utils/fieldMapper";

const { Text, Title, Paragraph } = Typography;

const InfoItem = (props) => {
    if (props.value === null || props.display === false || 
        props.value === undefined || props.value === '' || 
        props.value === 'null') {
        return null;
    }
    
    const displayValue = props.fieldType 
        ? getFieldDisplayName(props.value, props.fieldType)
        : props.value;
    
    // Additional check after processing the display value
    if (!displayValue || displayValue === '' || displayValue === 'null') {
        return null;
    }
    
    return (
        <div className="info-item">
            <Text type="secondary" className="info-label">{props.field}</Text>
            <Text className="info-value">{displayValue}</Text>
        </div>
    );
}

const ContactPreferenceTag = (props) => {
    if (props.value === false) {
        return <></>;
    }
    return (
        <Tag 
            bordered={false} 
            color={props.color} 
            className="contact-preference-tag"
        >
            {props.key_cn}
        </Tag>
    );
}

const ProfileHeader = (props) => {
    const p = props.profile;
    
    const middleSchoolInfo = (() => {
        if (!p.schoolm_start_time && !p.schoolm_class) return null;
        if ((!p.schoolm_start_time || p.schoolm_start_time === 'null') && 
            (!p.schoolm_class || p.schoolm_class === 'null')) return null;
        
        const schoolText = (p.schoolm && p.schoolm !== 'null') ? `${p.schoolm} ` : '';
        const yearText = (p.schoolm_start_time && p.schoolm_start_time !== 'null') ? `${p.schoolm_start_time}级` : '';
        const classText = (p.schoolm_class && p.schoolm_class !== 'null') ? `${p.schoolm_class}班` : '';
        
        if (!yearText && !classText) return null;
        
        return `${schoolText}${yearText}${classText}`;
    })();
    
    const highSchoolInfo = (() => {
        if (!p.schoolh_start_time && !p.schoolh_class) return null;
        if ((!p.schoolh_start_time || p.schoolh_start_time === 'null') && 
            (!p.schoolh_class || p.schoolh_class === 'null')) return null;
        
        const schoolText = (p.schoolh && p.schoolh !== 'null') ? `${p.schoolh} ` : '';
        const yearText = (p.schoolh_start_time && p.schoolh_start_time !== 'null') ? `${p.schoolh_start_time}级` : '';
        const classText = (p.schoolh_class && p.schoolh_class !== 'null') ? `${p.schoolh_class}班` : '';
        
        if (!yearText && !classText) return null;
        
        return `${schoolText}${yearText}${classText}`;
    })();
    
    // Check if there's any school information to display
    const hasSchoolInfo = !!(middleSchoolInfo || highSchoolInfo);
    
    // Show separator if there's school info (regardless of content below)
    const shouldShowSeparator = hasSchoolInfo;
    
    // Debug logging
    // console.log('ProfileHeader Debug:', {
    //     name: p.name_cn,
    //     schoolm: p.schoolm,
    //     schoolm_start_time: p.schoolm_start_time,
    //     schoolm_class: p.schoolm_class,
    //     schoolh: p.schoolh,
    //     schoolh_start_time: p.schoolh_start_time,
    //     schoolh_class: p.schoolh_class,
    //     middleSchoolInfo,
    //     highSchoolInfo,
    //     hasSchoolInfo,
    //     shouldShowSeparator
    // });
    
    return (
        <div className="profile-header">
            <div className="profile-main-info">
                <Title level={2} className="profile-name">{p.name_cn}</Title>
                {shouldShowSeparator && <div className="profile-separator"></div>}
                <div className="profile-schools">
                    {middleSchoolInfo && (
                        <div className="school-info">
                            <Text className="school-label">初中:</Text>
                            <Text className="school-text">{middleSchoolInfo}</Text>
                        </div>
                    )}
                    {highSchoolInfo && (
                        <div className="school-info">
                            <Text className="school-label">高中:</Text>
                            <Text className="school-text">{highSchoolInfo}</Text>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

const SchoolCard = (props) => {
    if (props.school === null || props.school === undefined || props.school === '' || props.school === 'null') {
        return null;
    }
    
    var timeInterval = null;
    if (props.startTime != null || props.endTime != null) {
        const st = (props.startTime != null) ? props.startTime : '';
        const et = (props.endTime != null) ? props.endTime : '';
        timeInterval = `${st} - ${et}`;
    }
    
    return (
        <div className="education-item">
            <div className="education-header">
                <BookOutlined className="education-icon" />
                <Text strong className="education-school">{props.school}</Text>
            </div>
            <div className="education-details">
                <InfoItem field="学位" value={props.level} fieldType="academic_field"/>
                <InfoItem field="专业" value={props.major}/>
                <InfoItem field="时间" value={timeInterval}/>
            </div>
        </div>
    );
}

const EducationSection = (props) => {
    const p = props.profile;
    if (!p.school1 && !p.school2 && !p.school3 && !p.school4) {
        return null;
    }
    
    // Check if any school cards actually have content
    const schoolCards = [
        { school: p.school1, startTime: p.school1_start_time, endTime: p.school1_end_time, level: p.school1_level, major: p.school1_major },
        { school: p.school2, startTime: p.school2_start_time, endTime: p.school2_end_time, level: p.school2_level, major: p.school2_major },
        { school: p.school3, startTime: p.school3_start_time, endTime: p.school3_end_time, level: p.school3_level, major: p.school3_major },
        { school: p.school4, startTime: p.school4_start_time, endTime: p.school4_end_time, level: p.school4_level, major: p.school4_major }
    ];
    
    const hasValidSchools = schoolCards.some(card => 
        card.school && card.school !== null && card.school !== undefined && card.school !== '' && card.school !== 'null'
    );
    
    if (!hasValidSchools) {
        return null;
    }
    
    return (
        <div className="profile-section">
            <div className="section-header">
                <h4 className="section-title">
                    <BookOutlined /> 教育经历
                </h4>
            </div>
            <div className="section-content">
                <SchoolCard
                    school={p.school1}
                    startTime={p.school1_start_time}
                    endTime={p.school1_end_time}
                    level={p.school1_level}
                    major={p.school1_major}
                />
                <SchoolCard
                    school={p.school2}
                    startTime={p.school2_start_time}
                    endTime={p.school2_end_time}
                    level={p.school2_level}
                    major={p.school2_major}
                />
                <SchoolCard
                    school={p.school3}
                    startTime={p.school3_start_time}
                    endTime={p.school3_end_time}
                    level={p.school3_level}
                    major={p.school3_major}
                />
                <SchoolCard
                    school={p.school4}
                    startTime={p.school4_start_time}
                    endTime={p.school4_end_time}
                    level={p.school4_level}
                    major={p.school4_major}
                />
            </div>
        </div>
    );
}


const CareerSection = (props) => {
    const p = props.profile;
    
    // More comprehensive check for career information
    const hasEmployer = p.employer && p.employer !== null && p.employer !== undefined && p.employer !== '' && p.employer !== 'null';
    const hasJobField = p.job_field && p.job_field !== null && p.job_field !== undefined && p.job_field !== '' && p.job_field !== 'null';
    const hasJobDesc = p.job_desc && p.job_desc !== null && p.job_desc !== undefined && p.job_desc !== '' && p.job_desc !== 'null';
    
    if (!hasEmployer && !hasJobField && !hasJobDesc) {
        return null;
    }
    
    return (
        <div className="profile-section">
            <div className="section-header">
                <h4 className="section-title">
                    <BankOutlined /> 工作信息
                </h4>
            </div>
            <div className="section-content">
                <div className="career-info">
                    <InfoItem field="雇主" value={p.employer}/>
                    <InfoItem field="行业" value={p.job_field} fieldType="job_field"/>
                    <InfoItem field="职位" value={p.job_desc}/>
                </div>
            </div>
        </div>
    );
}

const contactCardFields = [
    {key: "loc_country", label: "所在国家"},
    {key: "loc_city", label: "地址"},
    {key: "pub_email", label: "邮箱"},
    {key: "phone", label: "电话"},
    {key: "wechat_id", label: "微信号"},
    {key: "linkedin", label: "领英"},
    {key: "homepage_link", label: "个人主页"},
    {key: "other_contact", label: "其他联系方式"},
];

const copyToClipboard = async (text, fieldName) => {
    try {
        await navigator.clipboard.writeText(text);
        message.success(`${fieldName} 已复制到剪贴板`);
    } catch (err) {
        // Fallback for older browsers
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
        message.success(`${fieldName} 已复制到剪贴板`);
    }
};



const ContactPreference = (props) => {
    const p = props.profile;
    if (!p.cp_career && !p.cp_local_gather && !p.cp_dating && !p.cp_academic) {
        return null;
    }
    
    return (
        <div className="contact-preferences">
            <Text className="preference-title">可以在这些方面联系我:</Text>
            <div className="preference-tags">
                <ContactPreferenceTag
                    value={p.cp_academic}
                    key_cn={"学术沟通（科研，选校，选专业等）"}
                    color="blue"
                />
                <ContactPreferenceTag
                    value={p.cp_career}
                    key_cn={"职业沟通（行业资源，工作内推等）"}
                    color="green"
                />
                <ContactPreferenceTag
                    value={p.cp_local_gather}
                    key_cn={"参加/组织当地校友聚会"}
                    color="orange"
                />
                <ContactPreferenceTag
                    value={p.cp_dating}
                    key_cn={"个人情感"}
                    color="magenta"
                />
            </div>
        </div>
    );
}

const ContactSection = (props) => {
    const profile = props.profile;
    
    // Filter contact fields that have values
    const contactRows = contactCardFields
        .map((field) => {
            const value = profile[field.key];
            if (value == null || value === undefined || value === '' || value === 'null') {
                return null;
            }
            return {
                key: field.key,
                label: field.label,
                value: value
            };
        })
        .filter(row => row != null);
        
    if (contactRows.length === 0) {
        return null;
    }
    
    return (
        <div className="profile-section">
            <div className="section-header">
                <h4 className="section-title">
                    <MailOutlined /> 联系方式
                </h4>
            </div>
            <div className="section-content">
                <div className="contact-table-container">
                    <table className="contact-table">
                        <tbody>
                            {contactRows.map((row) => {
                                let contactContent;
                                let icon;
                                
                                switch(row.key) {
                                    case "homepage_link":
                                    case "linkedin":
                                        icon = row.key === "linkedin" ? <LinkedinOutlined /> : <GlobalOutlined />;
                                        contactContent = <a href={row.value} target="_blank" rel="noopener noreferrer">{row.value}</a>;
                                        break;
                                    case "pub_email":
                                        icon = <MailOutlined />;
                                        contactContent = <a href={`mailto:${row.value}`}>{row.value}</a>;
                                        break;
                                    case "phone":
                                        icon = <PhoneOutlined />;
                                        contactContent = <Text>{row.value}</Text>;
                                        break;
                                    case "wechat_id":
                                        icon = <WechatOutlined />;
                                        contactContent = <Text>{row.value}</Text>;
                                        break;
                                    case "loc_country":
                                    case "loc_city":
                                        icon = <EnvironmentOutlined />;
                                        contactContent = <Text>{row.value}</Text>;
                                        break;
                                    default:
                                        icon = <HomeOutlined />;
                                        contactContent = <Text>{row.value}</Text>;
                                }
                                
                                const showCopyButton = ['phone', 'wechat_id', 'pub_email'].includes(row.key);
                                
                                return (
                                    <tr key={row.key} className="contact-table-row">
                                        <td className="contact-table-icon">
                                            {icon}
                                        </td>
                                        <td className="contact-table-label">
                                            {row.label}
                                        </td>
                                        <td className="contact-table-value" colSpan={showCopyButton ? 1 : 2}>
                                            {contactContent}
                                        </td>
                                        {showCopyButton && (
                                            <td className="contact-table-action">
                                                <button 
                                                    onClick={() => copyToClipboard(row.value, row.label)}
                                                    className="simple-copy-button"
                                                    title={`复制${row.label}`}
                                                    type="button"
                                                >
                                                    <CopyOutlined />
                                                </button>
                                            </td>
                                        )}
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
                <ContactPreference profile={profile}/>
            </div>
        </div>
    );
}

const MiscSection = (props) => {
    const p = props.profile;
    if (!p.misc_text || props.display === false) {
        return null;
    }
    
    return (
        <div className="profile-section">
            <div className="section-header">
                <h4 className="section-title">
                    <EditOutlined /> 其他信息
                </h4>
            </div>
            <div className="section-content">
                <div className="misc-content">
                    <Paragraph>{p.misc_text}</Paragraph>
                </div>
            </div>
        </div>
    );
}

const ProfileCard = (props) => {
    const p = props.profile;
    
    // More comprehensive checks for contact information
    const hasContactInfo = contactCardFields.some(field => {
        const value = p[field.key];
        return value != null && value !== undefined && value !== '' && value !== 'null';
    });
    
    // More comprehensive checks for education information
    const hasEducationInfo = (p.school1 && p.school1 !== null && p.school1 !== undefined && p.school1 !== '' && p.school1 !== 'null') ||
                            (p.school2 && p.school2 !== null && p.school2 !== undefined && p.school2 !== '' && p.school2 !== 'null') ||
                            (p.school3 && p.school3 !== null && p.school3 !== undefined && p.school3 !== '' && p.school3 !== 'null') ||
                            (p.school4 && p.school4 !== null && p.school4 !== undefined && p.school4 !== '' && p.school4 !== 'null');
    
    // More comprehensive checks for career information
    const hasCareerInfo = (p.employer && p.employer !== null && p.employer !== undefined && p.employer !== '' && p.employer !== 'null') ||
                         (p.job_field && p.job_field !== null && p.job_field !== undefined && p.job_field !== '' && p.job_field !== 'null') ||
                         (p.job_desc && p.job_desc !== null && p.job_desc !== undefined && p.job_desc !== '' && p.job_desc !== 'null');
    
    // More comprehensive check for misc information
    const hasMiscInfo = p.misc_text && p.misc_text !== null && p.misc_text !== undefined && p.misc_text !== '' && p.misc_text !== 'null';
    
    // Check if any sections besides header have content
    const hasAnyContent = hasContactInfo || hasEducationInfo || hasCareerInfo || hasMiscInfo;
    
    // Debug logging
    // console.log('ProfileCard Debug:', {
    //     name: p.name_cn,
    //     hasContactInfo,
    //     hasEducationInfo,
    //     hasCareerInfo,
    //     hasMiscInfo,
    //     hasAnyContent,
    //     contactFields: contactCardFields.map(field => ({ key: field.key, value: p[field.key] })),
    //     education: { school1: p.school1, school2: p.school2, school3: p.school3, school4: p.school4 },
    //     career: { employer: p.employer, job_field: p.job_field, job_desc: p.job_desc },
    //     misc: p.misc_text
    // });
    
    return (
        <div className={`modern-profile-card ${!hasAnyContent ? 'header-only' : ''}`}>
            <ProfileHeader profile={p} hasContentBelow={hasAnyContent} />
            {hasContactInfo && <ContactSection profile={p} />}
            {hasEducationInfo && <EducationSection profile={p} />}
            {hasCareerInfo && <CareerSection profile={p} />}
            {hasMiscInfo && <MiscSection profile={p} />}
        </div>
    );
};

export default ProfileCard;
